// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__UUGSc","title":"text__title__yUqth","body":"text__body__xsCV4","img":"text__img__DZBZU"};